<template>
    <website-page>
        <digital-signage-navigation></digital-signage-navigation>

        <div id="main-section" class="page inverted bg-gradient-light">
            <b-container class="container-lg">
                <h1 class="mx-auto small text-center mb-4" style="max-width: inherit" v-tr>
                    Interactive Kiosks & Wayfinding|Kiosques interactifs et navigation intelligente
                </h1>

                <b-row>
                    <b-col v-if="isMobileLayout" cols="12" md="6">
                        <e-img lazy fluid center src="img/features/interactive-kiosks-portrait-landscape.png" alt="Interactive Touch Screen Kiosks with Eye-In"/>
                    </b-col>
                    <b-col cols="12" md="6">
<!--                        <h3 class="mt-lg-4 mb-2" v-tr>-->
<!--                            Interact with your Customers|Interagissez avec vos visiteurs-->
<!--                        </h3>-->

                        <h4 v-tr>
                            Eye-In Media provides tailored Interactive Kiosks and Wayfinders for diverse industries!|
                            Eye-In Media fournit des outils et services de création de kiosques interactifs avec gestion des plans et de trajectoire!
                        </h4>

<!--                        <h4 v-tr>-->
<!--                            Offer an interactive map displaying the path to your establishments to your visitors and employees.-->
<!--                            Confirm the presence of your patients with check-in or ask them to make their next appointment directly at the kiosk.|-->
<!--                            Offrez un plan interactif avec affichage du chemin de vos établissements à vos visiteurs et employés.-->
<!--                            Confirmez la présence de vos patients avec l'enregistrement (Check-in) ou proposez leur de prendre leur prochain rendez-vous directement sur le kiosque.-->
<!--                        </h4>-->

                        <p class="mt-4 lead" v-tr>
                            Our interactive web kiosks are fully customizable and can be adjusted to your needs, while offering accessibility options for your visitors. Our solutions can also be transformed into a website and a mobile application. All content can be hosted in Canada or USA.|
                            Nos kiosques interactifs web sont complètement personnalisables et permettent de s'ajuster à vos besoins, tout en offrant des options d'accessibilité pour vos visiteurs. Nos solutions peuvent également se transformer en site internet et en application mobile.
                        </p>

                        <p class="mt-4 lead f-500" v-tr>
                            Registration (Check-in / out) - Appointment booking - Payments - Wayfinder - Forms - Directory - Queue Management - Feedback|
                            Enregistrement (Check-in / out) - Prise de rendez-vous - Paiements - Formulaires - Annuaire - File d'attente - Commentaires
                        </p>

                        <div class="text-center mt-5 mb-3">
                            <b-btn v-scroll-to="'#contact-us'" size="lg" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                            <b-btn v-if="!isMobileLayout" size="lg" class="ml-2" v-scroll-to="'#smart-navigation'" variant="light"><span v-tr>Discover Smart Navigation|Découvrez la navigation intelligente</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                        </div>
                    </b-col>
                    <b-col v-if="!isMobileLayout" cols="12" md="6">
                        <e-img lazy fluid center src="img/features/interactive-kiosks-portrait-landscape.png" alt="Interactive Touch Screen Kiosks with Eye-In"/>
                    </b-col>
                </b-row>

                <b-row class="mt-3">
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/carrefour-estrie.png" alt="Client Institut Physimed"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/place-de-la-cite.png" alt="Client Digital Signage Hopital Montfort Healthcare"/>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/shriners.png" alt="Client  Digital Signage Hospital Shriners"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/alexis-nihon.png" alt="Client Digital Signage Alexis Nihon"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/institut-douglas.png" alt="Client Institut Douglas Affichage numerique"></e-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <e-img src="img/clients-white/maimonides.png" alt="Client Maimonides Digital Signage"></e-img>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <div id="smart-navigation" class="page">
            <b-container class="text-center" :class="isMobileLayout ? 'text-center': ''">
                <h2 class="mb-4 small" v-tr>Smart Navigation|Navigation intelligente</h2>
                <h4 v-tr>Much More than a Map|Bien plus qu'un plan interactif</h4>
                <e-img fluid fluid-grow src="img/features/wayfinder-main-features-fr.png" alt="Photo de la destination, guide en réalité augmentée, assistant étape par étape" style="max-width: 1100px;"/>

                <div v-if="!isMobileLayout" class="text-center mt-3">
                    <b-btn class="mr-3" v-scroll-to="'#how-it-works'" variant="light"><span v-tr>Discover how it works|Découvrez comment ça marche</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="how-it-works" class="page inverted">
            <b-container class="text-center" :class="isMobileLayout ? 'text-center': ''">
                <h2 class="mb-4 small" v-tr>Discover how it works|Découvrez comment ça marche</h2>

                <e-youtube-player iframe-src="https://player.vimeo.com/video/1009999004?h=a930e45a23&app_id=58479" :poster="require('@/assets/img/video-splash/virtual-assistant-lakeshore-splash.jpg')"
                        class="mx-auto" style="max-width: 800px"/>

                <p class="lead" v-tr>
                    Eye-In Media is proud to announce the launch of its new Generation of Wayfinding Kiosk along with it's Mobile Navigation Assistant, for the Lakeshore General Hospital, part of the CIUSSS Ouest de l'île de Montréal.|
                    Eye-In Média est fier d'annoncer le lancement de sa nouvelle génération de borne de navigation intelligence, ainsi que son Assistant de navigation mobile pour l'Hôpital général du Lakeshore, qui fait parti du CIUSSS Ouest de l'île de Montréal.
                </p>

                <div class="text-center mt-3">
                    <b-btn variant="primary" href="https://visitelakeshore.ca" target="_blank">
                        <i class="fas fa-external-link mr-1"/>
                        <span v-tr>Open Online Wayfinder|Ouvrir l'outil de navigation</span>
                    </b-btn>
                </div>

                <div v-if="!isMobileLayout" class="text-center mt-3">
                    <b-btn class="mr-3" v-scroll-to="'#mobile-navigation-assistant'" variant="light"><span v-tr>Mobile Navigation Assistant|Assistant de navigation mobile</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="mobile-navigation-assistant" class="page">
            <b-container :class="isMobileLayout ? 'text-center': ''">
                <h2 class="mb-4 small text-center" v-tr>Mobile Navigation Assistant|Assistant de navigation mobile</h2>
                <b-row>
                    <b-col cols="12" md="6" xl="3">
                        <h4 class="mt-3 mt-lg-5 pt-lg-3" v-tr>Universal Kiosk Application|Application de kiosque universelle</h4>
                        <p v-tr>
                            Multi-Device Support allows users to access 3D navigation with augmented reality wherever they are. From home, it helps identify key landmarks before arriving at the hospital; on a mobile phone, it provides intuitive real-time guidance, and on kiosks, users can preview the environment before heading to their destination.|
                            Le support multi-appareils permet aux utilisateurs d'accéder à la solution de navigation intelligence où qu'ils se trouvent. Depuis chez eux, ils peuvent identifier des points de repère avant d'arriver à l'hôpital ; sur un téléphone portable, ils seront guidés par l'assistant virtuel en temps réel, et sur les kiosques, les utilisateurs peuvent visualiser le chemin à parcourir.
                        </p>
                    </b-col>
                    <b-col cols="12" md="6" xl="3">
                        <e-img fluid fluid-grow :src="`img/screenshots/wayfinder-mobile-map-${getLanguage()}.png`" alt="Mobile Wayfinding Application with Map"/>
                    </b-col>
                    <b-col cols="12" md="6" xl="3">
                        <e-img fluid fluid-grow :src="`img/screenshots/wayfinder-mobile-ar-view-${getLanguage()}.png`" alt="Mobile Wayfinding Application with Map"/>
                    </b-col>
                    <b-col cols="12" md="6" xl="3">
                        <h4 class="mt-3 mt-lg-5 pt-lg-3" v-tr>Augmented Reality View|Vue Réalité Augmentée</h4>
                        <p v-tr>
                            By integrating 3D visuals and augmented reality, users can easily follow directional arrows and landmarks that align with the real environment. This innovative approach enhances orientation, making navigation intuitive and reducing the stress of finding your way.|
                            En intégrant des visuels 3D et la réalité augmentée, les utilisateurs peuvent facilement suivre des flèches directionnelles et des points de repère alignés avec l'environnement réel. Cette approche innovante améliore l'orientation, rendant la navigation intuitive et réduisant le stress de se repérer.
                        </p>
                    </b-col>
                </b-row>

                <div class="text-center mt-5 mb-3">
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#key-features'" variant="light"><span v-tr>Key Features|Fonctionnalités clés</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="key-features" class="page inverted">
            <b-container class="text-center" :class="isMobileLayout ? 'text-center': ''">
                <h2 class="mb-4 small" v-tr>Interactive Kiosks Key Features|Fonctionnalités clés des kiosques interactifs</h2>
                <b-row>
                    <b-col cols="12" md="4">
                        <e-img fluid fluid-grow rounded class="shadow" src="img/features/kiosk-map-wayfinder.jpg" alt="Manage your Hospital screens by email"/>
                        <h3 class="small mt-3" v-tr>Maps & Wayfinding|Plans et trajectoires</h3>

                        <p class="lead" v-tr>
                            Provides customers with Wayfinding inside your Establishments, including multiple floors. Create QR Code to send the information on Smartphones.|
                            Offrez l'affichage du chemin à l'intérieur de votre établissement à vos clients. Envoyez le lien vers le chemin sur le téléphone de vos visiteurs.
                        </p>

<!--                        <b-btn v-scroll-to="'#automate-management'" size="lg" variant="primary" class="mt-3">-->
<!--                            <span v-tr>Email to Screen|Nouveauté : gestion par courriel</span>-->
<!--                            <i class="fas fa-chevron-right ml-1"/>-->
<!--                        </b-btn>-->
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img fluid fluid-grow src="img/features/kiosk-search-categories.png" alt="Add widgets and zones to dynamise your screens"/>
                        <h3 class="small mt-3" v-tr>Search and Categories|Recherche et catégories</h3>
                        <p class="lead" v-tr>
                            Multiple tools are available to quickly find what visitors are looking for: Search Field, list of all Categories of Stores or Rooms, List of Points of Interests by Initial letter...|
                            De multiples outils sont disponibles pour permettre aux visiteurs de trouver rapidement ce qu'ils cherchent : Champ de recherche, liste de toutes les catégories de magasins ou de salles, ou encore la liste par initiales...
                        </p>

<!--                        <b-btn v-scroll-to="'#dynamize-screens'" size="lg" class="mt-3" variant="primary"><span v-tr>Dynamize your Screens|Dynamisez vos écrans</span>-->
<!--                            <i class="fal fa-chevron-right ml-1"/>-->
<!--                        </b-btn>-->
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img fluid fluid-grow src="img/features/kiosk-map-wayfinder-directory.png" alt="Powerful Interactive Touch Screen Kiosks"/>
                        <h3 class="small mt-3" v-tr>Complete Directory|Annuaire complet</h3>
                        <p class="lead" v-tr>
                            List all point of interests within your establishment, including list of stores, rooms, employees, services... Screens can also be divided side-by-side with your map.|
                            Listez tous les points d'intérêt au sein de votre établissement, y compris la liste des magasins, des salles, des employés, des services... Les écrans peuvent également être divisés côte à côte avec votre plan.
                        </p>

<!--                        <b-btn v-scroll-to="'#interactive-kiosks'" size="lg" variant="primary" class="mt-3">-->
<!--                            <span v-tr>Interactive Kiosks|Kiosques interactifs</span>-->
<!--                            <i class="fas fa-chevron-right ml-1"/>-->
<!--                        </b-btn>-->
                    </b-col>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#kiosk-specifications'" variant="light"><span v-tr>Kiosk Specifications|Spécifications d'un kiosque</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="kiosk-specifications" class="page bg-white">
            <b-container>
                <h2 class="text-center" v-tr>Customize your Kiosk|Personnalisez votre kiosque</h2>
                <h4 class="text-center mb-5">
                    <span v-tr>Multiple size, multiple mounts, any orientation|Plusieurs tailles, plusieurs supports, n'importe quelle orientation</span>
                </h4>
                <p class="lead text-center" v-tr>Example of Kiosk Stand Specifications with built-in TV integration|Exemple de spécifications de support à kiosque avec écran intégré</p>
                <e-img lazy fluid :src="`img/features/kiosk-specifications-${getLanguage()}.png`"/>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#advanced-features'" variant="light"><span v-tr>Advanced features|Fonctionnalités avancées</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="advanced-features" class="page inverted">
            <b-container>
                <h2 class="text-center mb-3" v-tr>Advanced features|Fonctionnalités avancées</h2>
                <b-row>
                    <feature-card src="img/icons/survey.png">
                        <h4 class="mt-4" v-tr>Check-In, Appointment and Surveys|Enregistrement, RDV et Sondages</h4>
                        <p class="text-justify lead" v-tr>
                            Confirm the presence of your visitors with check-in or ask them to make their next appointment directly at the kiosk.|
                            Confirmez la présence de vos visiteurs avec l'enregistrement (Check-in) ou proposez leur de prendre leur prochain rendez-vous directement sur le kiosque.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/qr-code.png">
                        <h4 class="mt-4" v-tr>Send Information to Phones|Envoyer au téléphone</h4>
                        <p class="text-justify lead" v-tr>
                            Every path can generate a unique QR Code that allows you to find your way on your phone even after leaving the kiosk.|
                            Chaque chemin peut générer un QR Code unique qui vous permet de vous repérer sur votre téléphone même après avoir quitté le kiosque.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/internet.png">
                        <h4 class="mt-4" v-tr>Synchronized with your website|Synchronisé avec votre site internet</h4>
                        <p class="text-justify lead" v-tr>
                            The kiosk can use the data from your Website and make sure it's always up to date without any manual intervention.|
                            Le kiosque peut utiliser les données de votre site internet pour s'assurer d'être toujours à jour sans aucune intervention manuelle.
                        </p>
                    </feature-card>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#interactive-kiosk'" variant="light"><span v-tr>Why choose Eye-In|Pourquoi choisir Eye-In</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="why-chose-eyein" class="page">
            <b-container>
                <h2 class="text-center mb-5" v-tr>
                    Why choose Eye-In for your Digital Signage?|
                    Pourquoi choisir Eye-In pour votre affichage numérique?
                </h2>

                <b-row>
                    <feature-card src="img/icons/shop.png" :to="'/digital-signage/services|/affichage-numerique/services'|tr" alt="Turnkey Solution">
                        <h4 v-tr>Turnkey Solution|Solution clé en main</h4>
                        <p v-tr>
                            Installation, configuration, content creation, support, mobile applications...|
                            Installation, configuration, création de contenu, support, applications mobiles ...
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/call-center.png" :to="'/digital-signage/services|/affichage-numerique/services'|tr" alt="Excellent Customer Support">
                        <h4 v-tr>Excellent customer support|Excellent support technique</h4>
                        <p v-tr>
                            Client satisfaction is the most important at Eye-In Media|
                            La satisfaction de nos clients est une de nos priorité
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/thumb-up.png" :to="'/digital-signage/storyboard/infinite|/affichage-numerique/storyboard/infinite'|tr" alt="No graphics designer required">
                        <h4 v-tr>No specialist required|Aucun spécialiste requis</h4>
                        <p v-tr>
                            No programmer or graphic designer required even to integrate external feeds (ex trivia, RSS feeds, traffic, weather)|
                            Aucun programmeur ou graphiste requis même pour intégrer des flux externes (ex trivia, flux RSS, trafic et météo)
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/tv.png" alt="No screen or storage limits">
                        <h4 v-tr>No Restrictions|Aucune limite</h4>
                        <p v-tr>
                            There is no limit for the number of screens or storage|
                            Il n'y a pas de limite pour le nombre d'écrans ou de stockage
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/code.png" alt="Eye-In always invest in Research & Development">
                        <h4 v-tr>Constant R&D|R&D continue</h4>
                        <p v-tr>
                            Our software is always evolving with improved features and functionalities|
                            Notre logiciel évolue constamment avec des nouvelles fonctions et des améliorations
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/qr-code.png" alt="Easily create and print QR codes for menu boards">
                        <h4 v-tr>QR Codes|Codes QR</h4>
                        <p v-tr>
                            Generate <b>QR Codes</b> for your content directly within the application|
                            Générez des <b>codes QR</b> pour votre contenu directement dans l'application
                        </p>
                    </feature-card>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-3" v-scroll-to="'#customers-realizations'" variant="light"><span v-tr>Customers Realizations|Réalisations de nos clients</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="customers-realizations" class="page inverted">
            <b-container>
                <h2 class="text-center mb-4" v-tr>
                    Example of Customers Implementation|Réalisations de nos clients
                </h2>
                <h4 class="text-center mb-4" v-tr>
                    Example of real implementation of Interactive Kiosks made by Eye-In Media|Exemple d'implémentations de kiosques interactifs réalisés par Eye-In Media
                </h4>
                <b-row>
                    <b-col cols="12" md="4">
                        <e-img class="mb-3" rounded lazy fluid center src="img/examples/kiosk-carrefour-estrie-home.jpg" alt="Interactive Touch Screen Kiosks with Eye-In"/>
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img class="mb-3" rounded lazy fluid center src="img/examples/kiosk-carrefour-estrie-search.jpg" alt="Interactive Touch Screen Kiosks with Eye-In"/>
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img class="mb-3" rounded lazy fluid center src="img/examples/kiosk-mach-map.jpg" alt="Interactive Touch Screen Kiosks with Eye-In"/>
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img class="mb-3" rounded lazy fluid center src="img/examples/kiosk-place-de-la-cite-home.jpg" alt="Interactive Touch Screen Kiosks with Eye-In"/>
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img class="mb-3" rounded lazy fluid center src="img/examples/kiosk-place-de-la-cite-map.jpg" alt="Interactive Touch Screen Kiosks with Eye-In"/>
                    </b-col>
                    <b-col cols="12" md="4">
                        <e-img class="mb-3" rounded lazy fluid center src="img/examples/kiosk-inventory-shopping-mall.jpg" alt="Interactive Touch Screen Kiosks with Eye-In"/>
                    </b-col>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-3" v-scroll-to="'#clients'" variant="outline-light"><span v-tr>Our Clients|Nos clients</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="clients" class="page">
            <b-container>
                <h3 class="text-center" v-tr>They chose us|Ils nous ont choisis</h3>

                <signage-shopping-mall-client-cards/>
                <signage-corporate-office-client-cards/>

                <div class="text-center">
                    <router-link class="mt-3" :to="'/digital-signage/clients|/affichage-numerique/clients'|tr" variant="primary"><span v-tr>All our clients and markets|Tous nos clients et marchés</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    <br>
                    <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#contact-us'" variant="light"><span v-tr>Contact Us|Nous contacter</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>
    </website-page>
</template>

<script>
    import DigitalSignageNavigation from "@/navigation/digital-signage-navigation.vue";
    import EYoutubePlayer from "../../../vue-components/components/e-youtube-player.vue";
    import {isFrench, translate} from "../../../vue-components/helpers/i18n.js";
    import SignageCorporateOfficeClientCards from "../../client-cards/signage-corporate-office-client-cards.vue";
    import SignageShoppingMallClientCards from "../../client-cards/signage-shopping-mall-client-cards.vue";

    export default {
        name: `digital-signage-interactive-touch-kiosk`,
        methods: {isFrench},
        components: {EYoutubePlayer, SignageShoppingMallClientCards, SignageCorporateOfficeClientCards, DigitalSignageNavigation},
        metaInfo: {
            title: translate(`Interactive Touch Screen Kiosks for Malls and Clinics|Kiosques interactifs tactiles`),
            meta: [
                { name: `keywords`, content: `interactive, touch, screen, kiosk, appointment, wayfinding, digital, registration, check-in, registration` },
                { name: `description`, content: translate(`Eye-In Media provides tools and services for creating interactive kiosks with powerful wayfinding!|Eye-In Media fournit des outils et services de création de kiosques interactifs dotés d'une orientation puissante`) }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .main-section {
        background-color: #151e28;
        //background-image: url('../../assets/img/backgrounds/menu-board-thai-express.jpg');
        background-size: cover;
    }
</style>
